import { getPageRoutes } from "routes/pageRoutes";
import { Button, ButtonProps } from "@chakra-ui/react";
import { AppForm, FormField } from "@picovico/ui";
import { useChangePasswordMutation } from "@store/services/auth";
import * as yup from "yup";
import { useRouter } from "next/router";
import { catchErrorHandler, parseApiError } from "@picovico/utils";
import { useAppToast } from "@/hooks/useAppToast";

export interface changePasswordValues {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

const changePasswordValidationSchema = yup.object().shape({
  current_password: yup.string().required().label("Current Password"),
  new_password: yup.string().required().label("Password"),
  confirm_password: yup
    .string()
    .oneOf(
      [yup.ref("new_password")],
      "Confirm password doesn't match with new password",
    )
    .label("Confirm Password"),
});

const initialValues: changePasswordValues = {
  current_password: "",
  new_password: "",
  confirm_password: "",
};

function ChangePasswordForm({
  formProps,
  saveButtonProps,
  ...props
}: {
  formProps?: any;
  saveButtonProps?: ButtonProps;
  [key: string]: unknown;
}) {
  const { error: errorToast, success } = useAppToast();
  const [changePassword, { isLoading, error }] = useChangePasswordMutation({});
  const router = useRouter();

  return (
    <AppForm<changePasswordValues>
      apiError={(error && parseApiError(error)) || null}
      formProps={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",
        gap: "1rem",
        mt: "1.5rem",
        ...props,
      }}
      initialValues={initialValues}
      validationSchema={changePasswordValidationSchema}
      onSubmit={(values, { resetForm }) => {
        changePassword(values)
          .unwrap()
          .then((res) => {
            if (!res.data) return;
            res?.data?.message && success(res.data.message);
            router.push(getPageRoutes("profile"));
            resetForm();
          })
          .catch((err) => {
            catchErrorHandler(err, errorToast);
          });
      }}
    >
      <FormField
        name="current_password"
        type="password"
        label="Current Password"
        required
        {...formProps}
        apierror={parseApiError(error)}
        placeholder="Enter current password"
      />
      <FormField
        name="new_password"
        type="password"
        label="New Password"
        required
        placeholder="Enter new password"
        {...formProps}
        apierror={parseApiError(error)}
      />
      <FormField
        name="confirm_password"
        type="password"
        label="Confirm New Password"
        required
        placeholder="Re-enter new password"
        {...formProps}
        apierror={parseApiError(error)}
      />

      <Button
        isLoading={isLoading || false}
        isDisabled={isLoading || false}
        my="1rem"
        w="full"
        type="submit"
        {...saveButtonProps}
      >
        Save
      </Button>
    </AppForm>
  );
}

export default ChangePasswordForm;
